import { CommunityOwner } from '../interfaces';
import { CommunityGroup } from '../interfaces/community-owner';

export type CommunityProfile = CommunityOwner & {
  bio?: string;
  posts_count?: number;
};

export function transformGroupToProfile(group: CommunityGroup | undefined): CommunityProfile {
  if (!group) {
    return {} as CommunityProfile;
  }

  return {
    username: group.name,
    name: group.name,
    bio: group.description,
    email: '',
    phone: '',
    description: group.description,
    display_name: '',
    avatar_url: group.avatar?.url || '',
    cover_url: group.cover?.url || '',
    passport_uuid: group.id.toString(),
    userId: group.id.toString(),
    social_networks: {},
    follower_count: 0,
    posts_count: 0,
    types: [],
  };
}

export function transformOwnerToProfile(owner: CommunityOwner | undefined): CommunityProfile {
  if (!owner) {
    return {} as CommunityProfile;
  }

  return {
    ...owner,
    bio: owner.description,
  };
}
